import { LoqateAddressRetrieveType } from '../../../models/loqate-address-retrieve-type';
import client from '../client-unauthenticated';

const addressRetrieve = async (
  id: string
): Promise<LoqateAddressRetrieveType> => {
  const { data } = await client.get<LoqateAddressRetrieveType>(
    '/address-retrieve',
    {
      params: { id },
    }
  );

  return data;
};

export default addressRetrieve;
